import { render, staticRenderFns } from "./directive.vue?vue&type=template&id=3a6147a9&scoped=true"
import script from "./directive.vue?vue&type=script&lang=js"
export * from "./directive.vue?vue&type=script&lang=js"
import style0 from "./directive.vue?vue&type=style&index=0&id=3a6147a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6147a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6147a9')) {
      api.createRecord('3a6147a9', component.options)
    } else {
      api.reload('3a6147a9', component.options)
    }
    module.hot.accept("./directive.vue?vue&type=template&id=3a6147a9&scoped=true", function () {
      api.rerender('3a6147a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/directive.vue"
export default component.exports